import * as React from "react";

import { IconButton, IconButtonProps } from "./IconButton";

interface SelectableButtonProps extends IconButtonProps {
    isSelected?: boolean;
}

export const SelectableButton = (props: SelectableButtonProps) => {
    const { glyph, imagePath, isSelected = false, className, ...rest } = props;
    const btnClassName = `${className} ${isSelected ? "selectedButton" : ""}`;

    return <IconButton className={btnClassName} glyph={glyph} imagePath={imagePath} {...rest} />;
};
